@switch (state()) {
  @case ('loading') {
    <div class="flex justify-center py-12">
      <mat-progress-spinner mode="indeterminate" diameter="48" />
    </div>
  }
  @case ('error') {
    <ui-api-error
      message="Die Zusatzleistungen konnten nicht geladen werden."
      [showRetry]="true"
      (retry)="retry.emit()"
    />
  }
  @case ('success') {
    @if (tiles().length === 0) {
      <p class="text-base text-gray-600">
        Für deine Angaben gibt es keine zusätzlichen Leistungen zur Auswahl.
      </p>
    } @else {
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        @for (tile of tiles(); track tile.kachel.id) {
          <ui-selectable-tile
            [title]="tile.kachel.name"
            [description]="tile.kachel.beschreibung"
            [logoUrl]="tile.kachel.logoUrl"
            [tooltip]="tile.kachel.tooltip"
            [selected]="tile.selected"
            (toggled)="form().toggleKachel(tile.kachel)"
          />
        }
      </div>
    }
  }
}
